import { App, Button, Card, Col, Form, Input, Row, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { API } from '../../../config/api';
import { GET, PUT } from '../../../utils/apicalls';

function UpdateCourseOutline() {
    const [isLoading, setIsLoading] = useState(false);
    const [courseoutlineData, setCourseOutlinedata] = useState<any>([]);
    const [form] = Form.useForm();
    const [allCourseData, setallCourseData] = useState<any>([]);
    const { notification } = App.useApp();
    const { id } = useParams();
    const navigate = useNavigate();

    const fetchCourseOutline = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_COURSE_OUTLINE_BY_ID + id, {});
            setCourseOutlinedata(response?.data);
            form.setFieldsValue({
                courseoutlineTitle: response?.data?.courseoutlineTitle || '',
                Course_id: Number(response?.data?.Course_id) || 0,
                content: response?.data?.content?.map((desc: string) => ({ description: desc })) || [],

            });
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCourseOutline();
    }, []);

    const submitHandler = async (values: any) => {
        try {
            let content = values.content.map((item: any) => item.description);


            let obj = {
                courseoutlineTitle: values.courseoutlineTitle,
                Course_id: Number(values.Course_id),
                content: content, // This is now an array of strings

            };

            setIsLoading(true);
            const postRequest = await PUT(API.UPDATE_COURSE_OUTLINE + id, obj);

            if (postRequest) {
                notification.success({ message: " updated successfully!" });
                form.resetFields();
                fetchCourseOutline();
                navigate(-1);
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };


    const feacthallCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthallCourse();
    }, []);

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4" style={{ textAlign: "center" }}>Update Course Outline</h1>
            <Card className="p-4 shadow-md rounded-md">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={submitHandler}
                    className="flex flex-wrap gap-4"
                >
                    <Row gutter={16}>
                        {/* Course Title */}
                        <Col span={8}>
                            <Form.Item
                                label="Course outline Title"
                                name="courseoutlineTitle"
                                rules={[{ required: true, message: 'Please input the course outline title!' }]}
                            >
                                <Input placeholder="Enter course outline title" />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="Course"
                                name="Course_id"
                                rules={[{ required: true, message: 'Please select a Course!' }]}
                            >
                                <Select placeholder="Select a Course">
                                    {allCourseData.map((Course: { id: number; course_title: string }) => (
                                        <Select.Option key={Course.id} value={Course.id}>
                                            {Course.course_title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="Course  outline Description"
                                name="content"
                                rules={[{ required: true, message: 'Please input at least one description!' }]}
                            >
                                <Form.List
                                    name="content"
                                    initialValue={[]}
                                    rules={[
                                        {
                                            validator: async (_, names) => {
                                                if (!names || names.length < 1) {
                                                    return Promise.reject(new Error('At least one description is required'));
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                                                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'description']}
                                                        rules={[{ required: true, message: 'Please input a description!' }]}
                                                    >
                                                        <Input placeholder="Enter description" />
                                                    </Form.Item>
                                                    <Button onClick={() => remove(name)} icon="-">
                                                        Remove
                                                    </Button>
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} icon="+">
                                                    Add Description
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Form.Item>
                        </Col>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={isLoading}>
                                {isLoading ? 'Updating...' : 'Update Course module'}
                            </Button>
                        </Form.Item>
                    </Row>

                </Form>
            </Card>
        </div>
    );
}

export default UpdateCourseOutline
